import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormCheck, FormGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Field } from 'react-final-form';

type IFinalFormYesNo = {
  name: string;
  label: string;
  className?: string;
  disabled?: boolean;
  info?: string;
};

const FinalFormYesNo = (props: IFinalFormYesNo) => {
  return (
    <Field
      name={props.name}
      type='checkbox'
      format={(v) => v === 'Y'} // https://stackoverflow.com/questions/59832895/how-to-format-the-value-of-a-checkbox-field-using-react-final-form-field-array
      parse={(v) => (v ? 'Y' : 'N')}
    >
      {({ input }) => (
        <FormGroup className={props.className}>
          <FormCheck
            {...input}
            id={props.name}
            label={props.label}
            disabled={props.disabled}
            type='checkbox'
            className={props.info ? 'd-inline-block mr-3' : undefined}
          />
          {props.info && (
            <OverlayTrigger
              overlay={<Tooltip id={props.name}>{props.info}</Tooltip>}
            >
              <FontAwesomeIcon icon={faInfoCircle} />
            </OverlayTrigger>
          )}
        </FormGroup>
      )}
    </Field>
  );
};

export default FinalFormYesNo;
